export default __webpack_public_path__ + "static/media/DailyDelivery.e2bb59dc.webp";